var _linearGradient, _linearGradient2, _linearGradient3, _linearGradient4, _linearGradient5, _linearGradient6, _mask, _mask2, _mask3, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgYt(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 12,
    viewBox: "0 0 16 12",
    width: 16,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: "50%",
    x2: "50%",
    y1: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f0f0f0"
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: "50%",
    x2: "50%",
    y1: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1b2ca9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#132294"
  }))), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: "50%",
    x2: "50%",
    y1: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e6402c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d1321f"
  }))), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: "50%",
    x2: "50%",
    y1: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d0d0d0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c4c4c4"
  }))), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    x1: "50%",
    x2: "50%",
    y1: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#262626"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0d0d0d"
  }))), _linearGradient6 || (_linearGradient6 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "f",
    x1: "50%",
    x2: "50%",
    y1: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f7e04b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ead135"
  }))), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "g",
    fill: "#fff"
  })), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "h",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 .37409919c0-.20660928.16369048-.37409919.37919907-.37409919h3.05112567c.20942586 0 .37919907.17362322.37919907.37409919v3.8232302c0 .20660927-.16626703.38010502-.38139144.39764995 0 0-1.14241808-.02355077-1.52337047.6930601-.38095238-.71661087-1.52337046-.6930601-1.52337046-.6930601-.21063668-.01300673-.38139144-.19717399-.38139144-.39764995z",
    fill: "#fff",
    fillRule: "evenodd"
  }))), _mask3 || (_mask3 = /*#__PURE__*/React.createElement("mask", {
    id: "i",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 .37409919c0-.20660928.16369048-.37409919.37919907-.37409919h3.05112567c.20942586 0 .37919907.17362322.37919907.37409919v3.8232302c0 .20660927-.16626703.38010502-.38139144.39764995 0 0-1.14241808-.02355077-1.52337047.6930601-.38095238-.71661087-1.52337046-.6930601-1.52337046-.6930601-.21063668-.01300673-.38139144-.19717399-.38139144-.39764995z",
    fill: "#fff",
    fillRule: "evenodd"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    mask: "url(#g)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(6.095238 3.047619)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 .37409919c0-.20660928.16369048-.37409919.37919907-.37409919h3.05112567c.20942586 0 .37919907.17362322.37919907.37409919v3.8232302c0 .20660927-.16626703.38010502-.38139144.39764995 0 0-1.14241808-.02355077-1.52337047.6930601-.38095238-.71661087-1.52337046-.6930601-1.52337046-.6930601-.21063668-.01300673-.38139144-.19717399-.38139144-.39764995z",
    fill: "#d8d8d8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m.38095238.38095018v3.81637921c0 .00053301.01553633.01690422-.00741255.01677849.00242054-.00004687.00242054-.00004687.0070249-.0001044.26073467-.00275838.60430267.03677518.9524998.1620928.21727286.07819743.4104709.1832971.57169737.31909696.16122648-.13579986.35442452-.24089953.57169738-.31909696.33807438-.1216744.67178486-.16248004.92955153-.16222507.01478873-.00362307.02257205-.0123744.02257205-.01654182v-3.81637921z",
    stroke: "#979797",
    strokeWidth: 0.761905
  }), /*#__PURE__*/React.createElement("g", {
    mask: "url(#h)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h3.809524v2.285714h-3.809524z",
    fill: "#000",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 0h3.809524v2.285714h-3.809524z",
    fill: "url(#b)"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#i)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 2.285714)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h3.809524v3.047619h-3.809524z",
    fill: "#000",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 0h3.809524v3.047619h-3.809524z",
    fill: "url(#c)"
  }))))), /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    mask: "url(#g)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(10.666667 2.285714)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m.79162016 1.31491816v-.35319011l.35123698-.19982329s-.34677269-.42368861-.17531622-.42368861c.20949591 0 1.08891078.27889152 1.31817337.42368861.22926258.14479709.3454793.31881287.37774367.64741444.03226437.32860156-.24074591.74786086-.24074591.74786086l-.13699776.3188244.60044643-.13583519s.09721437.62933488-.34481958 1.08840216c-.44203394.45906727-1.06231399.37295387-1.06231399.37295387l-.12476748-.37295387s-.40485491.15727307-.64295015.51362537c-.23809523.3563523-.30523548.97227166.08031064 1.35244606.38554613.3801744 1.02171689.34793527 1.32505581-.18652344 0 0 .12169829-.47270276-.15876117-.69494048-.28045945-.22223772-.47028764.23693983-.47888765.21163505-.05447764-.1602958-.12476748-.43387277.32593936-.43387277.45070685 0 .68257069.48460751.61774554.85718936s-.19489397.72632998-1.06845238.82552083c-.8735584.09919085-1.09840029-1.00804501-1.09840029-1.00804501s-.22265626-1.03324963 0-1.77934338c.22265625-.74609375.55268787-.76460193 1.22316777-1.17424665.67047992-.40964472-.4047619-.13890439-.4047619-.13890439s-.51060268.38406808-.67066592.24428013c-.16006324-.13978794.38802083-.70247395.38802083-.70247395z",
    fill: "url(#d)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.333333,
    cy: 1.333333,
    fill: "url(#e)",
    fillOpacity: 0.3,
    r: 1
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#g)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1 0 0 1 5.333333 2.285714)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m.79162016 1.31491816v-.35319011l.35123698-.19982329s-.34677269-.42368861-.17531622-.42368861c.20949591 0 1.08891078.27889152 1.31817337.42368861.22926258.14479709.3454793.31881287.37774367.64741444.03226437.32860156-.24074591.74786086-.24074591.74786086l-.13699776.3188244.60044643-.13583519s.09721437.62933488-.34481958 1.08840216c-.44203394.45906727-1.06231399.37295387-1.06231399.37295387l-.12476748-.37295387s-.40485491.15727307-.64295015.51362537c-.23809523.3563523-.30523548.97227166.08031064 1.35244606.38554613.3801744 1.02171689.34793527 1.32505581-.18652344 0 0 .12169829-.47270276-.15876117-.69494048-.28045945-.22223772-.47028764.23693983-.47888765.21163505-.05447764-.1602958-.12476748-.43387277.32593936-.43387277.45070685 0 .68257069.48460751.61774554.85718936s-.19489397.72632998-1.06845238.82552083c-.8735584.09919085-1.09840029-1.00804501-1.09840029-1.00804501s-.22265626-1.03324963 0-1.77934338c.22265625-.74609375.55268787-.76460193 1.22316777-1.17424665.67047992-.40964472-.4047619-.13890439-.4047619-.13890439s-.51060268.38406808-.67066592.24428013c-.16006324-.13978794.38802083-.70247395.38802083-.70247395z",
    fill: "url(#d)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.333333,
    cy: 1.333333,
    fill: "url(#e)",
    fillOpacity: 0.3,
    r: 1
  }))), /*#__PURE__*/React.createElement("path", {
    d: "m7.34002453 3.80952381c-.06482671.11206604-.10192929.24217633-.10192929.38095238 0 .42078838.34111638.76190476.76190476.76190476.42078834 0 .76190476-.34111638.76190476-.76190476 0-.13877605-.03710255-.26888634-.10192929-.38095238-.13173692.22773386-.37796313.38095238-.65997547.38095238s-.52823854-.15321852-.65997547-.38095238z",
    fill: "url(#a)",
    mask: "url(#g)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m7.23809524 6.85714286c-.21039419 0-.38095238-.1705582-.38095238-.38095238 0-.21039419.17055819-.38095238.38095238-.38095238.21039418 0 .38095238.17055819.38095238.38095238 0 .21039418-.1705582.38095238-.38095238.38095238zm1.52380952 0c-.21039421 0-.38095238-.1705582-.38095238-.38095238 0-.21039419.17055817-.38095238.38095238-.38095238s.38095238.17055819.38095238.38095238c0 .21039418-.17055817.38095238-.38095238.38095238z",
    fill: "url(#f)",
    mask: "url(#g)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgYt);
export default __webpack_public_path__ + "static/media/YT.8632836d3aab5868761b3eff5057cbea.svg";
export { ForwardRef as ReactComponent };